module.exports = __webpack_public_path__ + "uukipi.jpg?bfd422e4c7a978b1ed5b9b228e840638";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/uukipi.jpg
// module id = 726
// module chunks = 0